import { getRequestUrl, post } from '../utils';
import { API } from '../constants';
import { assign, FetchJsSdkConfigParams, isNumber, JsSdkOption } from '@libs/shared';

/**
 * 获取 jssdk 相关配置
 * @param params 参数对象
 * @param params.url 当前页面url，jssdk会根据url进行签名验证，默认不携带当前页面路径中hash部分
 * @param params.tenantId 租户ID，未登录场景下必传
 * @param params.scenario jssdk 场景参数，未登录场景按需传（public：外链场景；other：其他未登录场景）
 * @param params.isLogin 当前是否处于登录状态
 */
export const fetchJsSdkConfig = (params: FetchJsSdkConfigParams) => {
    const {
        url = window.location.href.replace(/#[\S\s]*/, ''),
        isLogin,
        tenantId,
        scenario = 'other',
        suiteId,
        suiteScenario
    } = params;

    if (!isLogin) {
        /**
         * 未登录场景下，需要用户提供 tenantId 参数
         * 如果没有 tenantId，则无法通过接口获取鉴权参数，也就意味着此时不需要发送该接口
         * 这里提前终止中止是为了类似 f-6685352345 中场景不会出现多余的接口报错
         */
        if (!tenantId) {
            return Promise.reject(new Error('tenantId is required'));
        }
        const params = {
            url,
            tenant_id: tenantId,
            jssdk_scenario: scenario
        };
        if (isNumber(suiteId)) {
            assign(params, {
                suite_id: suiteId
            });
        }
        if (suiteScenario) {
            assign(params, {
                suite_scenario: suiteScenario
            });
        }
        return post<JsSdkOption>(getRequestUrl(API.jssdk.public_config), params).then((res) => {
            return res.data;
        });
    }

    // 登录场景下，不需要传 tenantId 参数，此时后端直接从 session 中取，也不需要区分jssdk场景
    return post<JsSdkOption>(getRequestUrl(API.jssdk.private_config), {
        url
    }).then((res) => {
        return res.data;
    });
};
